import { gql } from '@apollo/client';

export const query = gql`
  query Balances {
    currentUser {
      id
      balances {
        amount {
          value
          currency {
            code
          }
        }
      }
    }
  }
`;
